import React, {Component, createRef} from 'react';
import {connect} from "react-redux";
import FJToolbarCommon from '../view/FJToolbarCommon';
import FJZoomScale from '../view/FJZoomScale';
import FJVoice from '../view/FJVoice';
import FJToolbarDevider from '../view/FJToolbarDevider';
import classNames from "classnames";
import {FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJTransform from "../view/FJTransform";
import FJTransparency from "../view/FJTransparency";
import FJSpeed from "../view/FJSpeed";
import FJToolbarFilterContainer from "./FJToolbarFilterContainer";
import FJCropIcon from "../../../icon/crop.svg";
import InlineSVG from "react-inlinesvg";
import FJToolbarIconButton from "../view/FJToolbarIconButton";
import FJLocalStore from "../../../store/FJLocalStore";

class FJToolbarVideoContainer extends Component {

	constructor(props) {
		super(props);

		this.dropDown = createRef();
	}


	render() {
    let {
      volume,
      zoomScale,
      volumeDataChange,
      zoomDataChange,
      adaptClick,
      mediaStatus,
      couldMask,
      handleCrop,
			opacityValue,
      speedChange,
      speed,
			opacityChange,
			onLinkFun,
			onRetryFun,
			mediaName
    } = this.props;
    let containerClass = classNames('c-toolbar-video', {active: this.props.active});
    let mediaSuccess = mediaStatus === FJViewConstant.MEDIA_STATUS_SUCCESS;
    return (
      <FJToolbarCommon className={containerClass}
											 mediaStatus={mediaStatus}
											 mediaName={mediaName}
											 onLinkFun={onLinkFun}
											 onRetryFun={onRetryFun}
			>
        <FJVoice volume={volume}
                 disabled={!mediaSuccess || speed !== 1}
                 volumeDataChange={volumeDataChange}/>
				<FJToolbarDevider/>
        <FJZoomScale zoomScale={zoomScale}
                     disabled={!mediaSuccess}
                     zoomDataChange={zoomDataChange}
                     adaptClick={adaptClick}
                     style={{marginRight: 6}}/>
				<FJToolbarDevider/>
				<FJTransform type='media'
										 disabled={!mediaSuccess}
				/>
        <FJToolbarIconButton icon={<InlineSVG src={FJCropIcon} element='div'/>}
                             style={{float: 'left', marginLeft: '6px'}}
                             onClick={handleCrop}
                             disabled={!mediaSuccess || !couldMask}
                             className='u-tooltip-bottom c-toolbar-icon-btn float-left'
                             tooltip={FJLocalStore._('crop') }
        />
				<FJToolbarDevider/>
				<FJTransparency opacityValue={opacityValue}
												opacityChange={opacityChange}
												disabled={!mediaSuccess}
				/>
				<FJToolbarDevider/>
				<FJToolbarFilterContainer mediaSuccess={mediaSuccess} />
        <FJToolbarDevider/>
        <FJSpeed speed={speed} onSpeedChange={speedChange} disabled={!mediaSuccess} dropDown={this.dropDown}/>
      </FJToolbarCommon>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    volume: state.toolbarVideo.volume,
    speed: state.toolbarVideo.speed,
    zoomScale: state.toolbarVideo.zoomScale,
    mediaStatus: state.toolbarVideo.mediaStatus,
		mediaName: state.toolbarVideo.mediaName,
    couldMask: state.toolbar.couldMask,
    isEditMode: state.toolbar.isEditMode,
    isShowEditMode: state.toolbar.isShowEditMode,
		opacityValue: state.toolbar.opacityValue
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    volumeDataChange: function (type, value) {
      dispatch(FJToolbarAction.videoVolumeDataChangeAction(type, value));
    },
    speedChange: function (value) {
      dispatch(FJToolbarAction.videoSpeedChangeAction(value));
    },
    zoomDataChange: function (type, value) {
      dispatch(FJToolbarAction.videoZoomDataChangeAction(type, value));
    },
    adaptClick: function (type) {
      dispatch(FJToolbarAction.videoAdaptiveChangeAction(type));
    },
    toggleEditMode: function () {
      dispatch(FJToolbarAction.toggleEditorModeAction());
    },
		opacityChange: function (type, value) {
			dispatch(FJToolbarAction.changeOpacityValueAction(type, value))
		},
    handleCrop: function () {
      dispatch(FJToolbarAction.setCropAction(true));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarVideoContainer);
